const BASE_URL = window.location.origin;

export const useInvokeAction = () => {
  return async (payload: any) => {
    const response = await fetch(
      `${BASE_URL}/wp-json/trumarket/v1/action/invoke`,
      {
        method: "POST",
        body: JSON.stringify(payload),
        headers: { "Content-Type": "application/json" },
      }
    );
    const invokeResponse = await response.json();
    return invokeResponse;
  };
};

export const useFetchDataSchema = () => {
  return async () => {
    const response = await fetch(
      `${BASE_URL}/wp-json/trumarket/v1/request-definition/data-schema`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );
    const dataSchemaResponse = await response.json();
    if (!response.ok) return false;
    else return dataSchemaResponse;
  };
};

export const useFetchUiSchema = () => {
  return async (uiSchemaKey: string, requestDefinitionKey: string) => {
    const uiSchemaResponse = await fetch(
      `${BASE_URL}/wp-json/trumarket/v1/request-definition/ui-schema`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          uiSchemaKey,
          requestDefinitionKey,
        }),
      }
    );
    const uiSchemaData = await uiSchemaResponse.json();
    if (!uiSchemaResponse.ok) return false;
    else return uiSchemaData;
  };
};

export const useFetchRequest = () => {
  return async (requestKey: string, uiSchemaType: string) => {
    const response = await fetch(
      `${BASE_URL}/wp-json/trumarket/v1/requests/${requestKey}/?uiSchemaType=${uiSchemaType}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );
    const requestData = await response.json();
    if (!response.ok) return false;
    else return requestData;
  };
};

export const useCreateRequest = () => {
  return async (data: any) => {
    const response = await fetch(
      `${BASE_URL}/wp-json/trumarket/v1/requests`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ data }),
      }
    );

    const requestData = await response.json();
    if (!response.ok) throw new Error('Error Creating Request');
    else return requestData;
  };
};

export const useFetchRequestDocument = () => {
  return async (requestKey: string) => {
    const response = await fetch(
      `${BASE_URL}/wp-json/trumarket/v1/request/${requestKey}/attachment`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );
    const documentData = await response.json();
    if (!response.ok) return false;
    else return documentData;
  };
};

export const useGetDownloadUrl = () => {
  return async (keys: string[], allDocs: boolean) => {
    const body = { "attachment_keys": keys}
    const response = await fetch(`${BASE_URL}/wp-json/trumarket/v1/attachment-management/attachment/download`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    const docs = await response.json();
    allDocs ? 
      docs.map((doc:any) => {
        return window.open(doc.downloadUrl);
      }) : window.open(docs[0].downloadUrl);
    return docs
  };
};

export const usePartialUpdate = () => {
  return async (body: any, requestKey: string) => {
    const response = await fetch(
      `${BASE_URL}/wp-json/trumarket/v1/request/${requestKey}`,
      {
        method: "PATCH",
        body: JSON.stringify(body),
      }
    );

    const partialData = await response;
    if (!response?.ok) return false;
    else return partialData;
  };
};

// Not Used , we do update phone with the same request for update client
// export const usePhoneUpdate = () => {
//   return async (body: any, requestKey: string) => {
//     const response = await fetch(
//       `${BASE_URL}/wp-json/trumarket/v1/requests/${requestKey}/client-phone`,
//       {
//         method: "PATCH",
//         body: JSON.stringify(body),
//       }
//     );

//     const partialData = await response;
//     if (!response?.ok) return false;
//     else return partialData;
//   };
// };

export const useClientUpdate = () => {
  return async (body: any, requestKey: string) => {
    const response = await fetch(
      `${BASE_URL}/wp-json/trumarket/v1/request-management/${requestKey}/client`,
      {
        method: "PATCH",
        body: JSON.stringify(body),
      }
    );

    const partialData = await response;
    if (!response?.ok) return false;
    else return partialData;
  };
};

export const useChangeUiSchema = () => {
  return async (body: any) => {
    const response = await fetch(
      `${BASE_URL}/wp-json/trumarket/v1/request-instance/uiSchema/change`,
      {
        method: "POST",
        body: JSON.stringify(body),
        headers: { "Content-Type": "application/json" },
      }
    );

    const uiSchema = await response.json();
    if (!response.ok) return false;
    else return uiSchema;
  };
};

export const useChangeStatus = () => {
  return async (body: {
    statusKey: string;
    statusType: "new" | "canceled" | "completed" | "others";
    requestInstanceKey: string;
    reason?: string;
  }) => {
    const response = await fetch(
      `${BASE_URL}/wp-json/trumarket/v1/request-instance/status/change`,
      {
        method: "POST",
        body: JSON.stringify(body),
        headers: { "Content-Type": "application/json" },
      }
    );

    if (!response.ok) return false;
    else return true;
  };
};
